import {useEffect, useCallback} from "react"

export interface WebPushMessage {
    topic: string
    [key: string]: any
}

export type WebPushMessageHandler = (message: WebPushMessage) => void

export function useWebPush(topic: string, callback: WebPushMessageHandler) {

    const handleMessage = useCallback((event: MessageEvent) => {
        console.log(`[web-push] received message:`, event.data)

        const data = event.data as WebPushMessage | undefined
        if (data && data.topic === topic) {
            callback(data)
        }
    }, [topic, callback])

    useEffect(() => {
        if (!('serviceWorker' in navigator)) {
            console.warn(`[web-push] Service Worker not supported, cannot listen for topic '${topic}'`)
            return
        }

        console.log(`[web-push] registering listener for topic '${topic}'`)
        navigator.serviceWorker.addEventListener('message', handleMessage)

        return () => {
            console.log(`[web-push] unregistering listener for topic '${topic}'`)
            navigator.serviceWorker.removeEventListener('message', handleMessage)
        }
    }, [topic, handleMessage])
}
